(function () {
  'use strict';

  var MONTHS = ['January','February','March','April','May','June','July',
    'August','September','October','November','December'];
  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var CUTOFF_HOUR = 10;

  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  function addDays(d, n) {
    var x = startOfDay(d);
    x.setDate(x.getDate() + n);
    return x;
  }
  function parseOverride(str) {
    if (!str) return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(str).trim());
    if (!m) return null;
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    return isNaN(d.getTime()) ? null : d;
  }
  function computeTarget(dubaiNow, override) {
    var today = startOfDay(dubaiNow);
    if (override) {
      var ov = startOfDay(override);
      if (ov.getTime() >= today.getTime()) return ov;
    }
    var dow = dubaiNow.getDay();
    var beforeCutoff = dubaiNow.getHours() < CUTOFF_HOUR;
    if (dow === 0) return addDays(today, 1);
    if (dow === 6) return beforeCutoff ? today : addDays(today, 2);
    return beforeCutoff ? today : addDays(today, 1);
  }
  function formatLabel(dubaiNow, target) {
    var diff = Math.round(
      (startOfDay(target).getTime() - startOfDay(dubaiNow).getTime()) / 86400000
    );
    var prefix = diff === 0 ? 'Today' : diff === 1 ? 'Tomorrow' : DAYS[target.getDay()];
    return prefix + ', ' + MONTHS[target.getMonth()] + ' ' + target.getDate();
  }
  function estimate(dubaiNow, overrideStr) {
    return formatLabel(dubaiNow, computeTarget(dubaiNow, parseOverride(overrideStr)));
  }
  function getDubaiNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Dubai', year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hour12: false
      }).formatToParts(new Date());
      var g = function (t) { return +parts.find(function (p) { return p.type === t; }).value; };
      var hour = g('hour'); if (hour === 24) hour = 0;
      return new Date(g('year'), g('month') - 1, g('day'), hour, g('minute'));
    } catch (e) {
      return new Date();
    }
  }
  function render(el) {
    if (!el) return;
    try {
      el.textContent = estimate(getDubaiNow(), el.getAttribute('data-override') || '');
    } catch (e) { /* leave JS-off fallback text in place */ }
  }
  function init() {
    var nodes = document.querySelectorAll('[data-pdpv2-delivery]');
    for (var i = 0; i < nodes.length; i++) render(nodes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PDPV2DeliveryEstimate = {
    estimate: estimate, computeTarget: computeTarget,
    parseOverride: parseOverride, formatLabel: formatLabel,
    getDubaiNow: getDubaiNow, render: render
  };
})();
